// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReferralModal_wrapper__3BOCe","headerFlagIcon":"ReferralModal_headerFlagIcon__1XQOJ"};